
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    props: {
        additionalService: {
            type: Array as PropType<any[]>,
            default: () => [],
        },
        short: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        const formatAmount = (amount: string | number | null) => {
            if (amount) {
                return `${amount.toLocaleString('ru-RU')} ₸`
            }

            return '-'
        }

        return {
            formatAmount,
        }
    },
})
